import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpParams,  HttpClient } from '@angular/common/http';
import { Tab2Page } from '../tab2/tab2';
import { GlobalProvider } from '../../providers/global/global';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';

/**
 * Generated class for the Tab1Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tab1',
  templateUrl: 'tab1.html',
})
export class Tab1Page {

  //local: string;
  res2: any;
  dt2: any;
  caption: Array<string> = [];
  id:string;

  constructor(public global: GlobalProvider,public http: HttpClient, public navCtrl: NavController,
    public navParams: NavParams, public popoverCtrl: PopoverController) {

    //this.local = localStorage.getItem('Auth');
    this.caption = this.navParams.get('caption');
    //console.log(typeof this.caption);
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }
  //commented 17122018
  httpRequest(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {



    this.id = this.navParams.get('id');


      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.timesheettype = this.global.timesheettype;
      p.contacttype = this.global.contacttype;
      p.id = this.id;
      p.entity = 'TAB2';

      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/timesheet_read/', params).subscribe(
        (data) => {
          this.global.loading.dismiss();

          this.res2 = data;
          //console.log(this.res2);
          if(this.res2.result == true){
            this.global.dt2 = JSON.parse(this.res2.dt);
          //var caption = [];
          //var Id = [];
          this.global.TAB2Caption=[];
          this.global.TAB2id = [];
          this.global.TAB2TotalTime=[];
            for(var i = 0; i < this.global.dt2.length; i++){
              
              this.global.TAB2Caption[i] = this.global.dt2[i]['Caption'];
              this.global.TAB2id[i] = this.global.dt2[i]['ID'];
              this.global.TAB2TotalTime[i] = this.global.dt2[i]['TotalTime'];
              this.global.dt2 = JSON.parse(this.res2.dt);

            }
            this.goToTab2();
          }


          else {


          }

        },
        error => {alert('error');}
      );

    }).catch((err) => {

    });
  }

  httpRequestTab2(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {


    //this.flag = true;

        var p:any={};
        p.timesheetid = this.global.timesheetid;
        p.timesheettype = this.global.timesheettype;
        p.contacttype = this.global.contacttype;
        p.id = this.global.id;
        p.entity = 'TAB2';

        const params = new HttpParams()
        .set('j',JSON.stringify(p))


        this.http.post('timesheets/timesheet_read/',params).subscribe(
          (data) => {

            this.global.loading.dismiss();
            //this.flag = false;

            this.res2 = data;
            //console.log(this.res2);
            if(this.res2.result == true){
              this.global.dt2 = JSON.parse(this.res2.dt);
            //var caption = [];
            //var Id = [];

            this.global.TAB2Caption=[];
            this.global.TAB2id = [];
            this.global.TAB2TotalTime=[];
              for(var i=0; i<this.global.dt2.length; i++){

                this.global.TAB2Caption[i] = this.global.dt2[i]['Caption'];
                this.global.TAB2id[i] = this.global.dt2[i]['ID'];
                this.global.TAB2TotalTime[i] = this.global.dt2[i]['TotalTime'];
                this.global.dt2 = JSON.parse(this.res2.dt);

              }
              this.goToTab2();
            }
            else {

            }

          },
          error => {alert('error');}
        );

      }).catch((err) => {

      });

  }

  goToTab2()
  {
    this.navCtrl.push(Tab2Page);
  }

  rowClick(){
    this.httpRequestTab2();

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad Tab1Page');
  }

}



// WEBPACK FOOTER //
// ./src/pages/tab1/tab1.ts